import { render, staticRenderFns } from "./resumocreditofinanceiro.vue?vue&type=template&id=5cdbe2c4&scoped=true&"
import script from "./resumocreditofinanceiro.vue?vue&type=script&lang=js&"
export * from "./resumocreditofinanceiro.vue?vue&type=script&lang=js&"
import style0 from "./resumocreditofinanceiro.vue?vue&type=style&index=0&id=5cdbe2c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdbe2c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VList,VListItem,VListItemTitle,VMenu})
